import React, { useEffect, useRef, useState } from 'react';
import {
    ChildContainer,
    Wrapper2,
    Wrapper2Container,
    Title,
    GraphLabelContainer,
    GraphLabelContainer2,
    GraphLabel,
    LabelContainer,
    LineContainer,
    FilterBtn,
    MainContainer,
    MainComponent2,
    ParagraphBold,
    ToggleButtonWrapper,
    Option,
    ParagraphNormal,
    DropDownWrapper,
    DropDownContentDiv,
    InputDropDownCheckBox,
    InputDivWrapper,
} from './ViewCompetitive.styled';

import Flip from '../../../assests/images/flipkart.png';
import Insta from '../../../assests/images/Instagram.png';
import YoutubeImg from '../../../assests/images/youtubeImg.png';

import TrendsInUserActivity from '../../CompetitiveIntelligence/TrendsInUserActivity';
import TrendsInSentiments from '../../CompetitiveIntelligence/Trends'
import { FacebookLogoSmall, filter_icon, X_LOGO } from '../../../Common/SvgIcon/CommonSvgIcons';


const ToggleButton = ({
    options = [],
    onClick = () => { },
    padding = '5px 20px',
    option
}) => {
    const [selectedOption, setSelectedOption] = useState(option || options[0]);
    const handleSelectOption = (option) => {
        setSelectedOption(option);
        onClick(option);
    };

    useEffect(() => {
        setSelectedOption(option);  // Update timeSpan whenever option changes
    }, [option]);  // This will run whenever the `option` prop changes


    return (
        <ToggleButtonWrapper>
            {options.map((option) => (
                selectedOption === option &&
                <Option
                    selected={selectedOption === option}
                    onClick={() => handleSelectOption(option)}
                    padding={padding}
                    key={option}
                >
                    {option}
                </Option>
            ))}
        </ToggleButtonWrapper>
    );
};

const TrendsMainContainer = ({
    isZoom80,
    jsonVal,
    theme = false, shared = false,
    desc = '',
    downloadFeature = false,
    showTitleForSentiment = false, option = 'Days', compData, trendsDataSet, showGraphLabel, summary1 = '', summary2 = '', analysisData, showsummary, showFilter = true }) => {
    const [timeSpan, setTimeSpan] = useState(option || 'Days');
    const divRef = useRef(null); // Step 1: Create a ref
    const [openDropDown, setOpenDropDown] = useState(false)
    const [topic1Filter, setTopic1Filter] = useState({
        positive: true,
        negative: true,
        neutral: true
    })

    const [topic2Filter, setTopic2Filter] = useState({
        positive: true,
        negative: true,
        neutral: true
    })
    const handleChangeMainFilter = (e) => {
        const { checked } = e.target;

        setTopic1Filter((prevVal) => ({
            ...prevVal,
            positive: checked,
            negative: checked,
            neutral: checked
        }));
    };
    const handleChangeMainFilter2 = (e) => {
        const { checked } = e.target;

        setTopic2Filter((prevVal) => ({
            ...prevVal,
            positive: checked,
            negative: checked,
            neutral: checked
        }));
    };
    const handleChangeFilter = (e) => {
        const { name, checked } = e.target;

        setTopic1Filter((prevVal) => ({
            ...prevVal,
            [name]: checked
        }));
    };

    const handleChangeFilter2 = (e) => {
        const { name, checked } = e.target;

        setTopic2Filter((prevVal) => ({
            ...prevVal,
            [name]: checked
        }));
    };
    useEffect(() => {
        setTimeSpan(option);  // Update timeSpan whenever option changes
    }, [option]);  // This will run whenever the `option` prop changes



    // console.log(topic1Filter, topic2Filter, "topic");
    const [divWidth, setDivWidth] = useState(0); // Step 2: State to store width
    let trendsInUserActivity = {

        Topic1TimeLine: [],
        Topic2TimeLine: [],
        Topic1Count: [],
        Topic2Count: []
    };

    let trendsInSentiments = {

        positive1: [],
        positive2: [],
        negative1: [],
        negative2: [],
        neutral1: [],
        neutral2: [],
        positive1val: [],
        positive2val: [],
        negative1val: [],
        negative2val: [],
        neutral1val: [],
        neutral2val: []

    };

    useEffect(() => {
        // Step 3: Access the width after the component mounts
        if (divRef.current) {
            setDivWidth(divRef.current.offsetWidth); // Get the width
        }

        const handleResize = () => {
            if (divRef.current) {
                setDivWidth(divRef.current.offsetWidth); // Update width on resize
            }
        };

        window.addEventListener('resize', handleResize); // Handle window resize
        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup
        };
    }, []);

    if (timeSpan === 'Days') {
        if (jsonVal?.postOption == "Comments") {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_comment_trends?.days?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_comment_trends?.days?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_comment_trends?.days?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_comment_trends?.days?.count || []

            }
        } else {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_trends?.days?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_trends?.days?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_trends?.days?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_trends?.days?.count || []

            }
        }
        trendsInSentiments = {

            positive1: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.days?.timeline || [],
            positive2: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.days?.timeline || [],
            negative1: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.days?.timeline || [],
            negative2: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.days?.timeline || [],
            neutral1: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.days?.timeline || [],
            neutral2: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.days?.timeline || [],


            positive1val: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.days?.count || [],
            positive2val: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.days?.count || [],
            negative1val: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.days?.count || [],
            negative2val: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.days?.count || [],
            neutral1val: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.days?.count || [],
            neutral2val: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.days?.count || []
        }
    } else if (timeSpan === 'Weeks') {
        if (jsonVal?.postOption == "Comments") {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_comment_trends?.week?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_comment_trends?.week?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_comment_trends?.week?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_comment_trends?.week?.count || []

            }
        } else {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_trends?.week?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_trends?.week?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_trends?.week?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_trends?.week?.count || []

            }
        }

        trendsInSentiments = {

            positive1: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.week?.timeline || [],
            positive2: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.week?.timeline || [],
            negative1: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.week?.timeline || [],
            negative2: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.week?.timeline || [],
            neutral1: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.week?.timeline || [],
            neutral2: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.week?.timeline || [],


            positive1val: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.week?.count || [],
            positive2val: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.week?.count || [],
            negative1val: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.week?.count || [],
            negative2val: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.week?.count || [],
            neutral1val: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.week?.count || [],
            neutral2val: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.week?.count || []
        }

        // trendsInUserActivity = compData?.[0]?.ci_report?.user_activity_trends?.week?.timeline || [];
        // trendsInUserActivityTopic2TimeLine = compData?.[1]?.ci_report?.user_activity_trends?.week?.timeline || [];
        // trendsInUserActivityTopic1Count = compData?.[0]?.ci_report?.user_activity_trends?.week?.count || [];
        // trendsInUserActivityTopic2Count = compData?.[1]?.ci_report?.user_activity_trends?.week?.count || [];
    } else if (timeSpan === 'Months') {
        if (jsonVal?.postOption == "Comments") {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_comment_trends?.month?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_comment_trends?.month?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_comment_trends?.month?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_comment_trends?.month?.count || []

            }
        } else {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_trends?.month?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_trends?.month?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_trends?.month?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_trends?.month?.count || []

            }
        }
        trendsInSentiments = {

            positive1: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.month?.timeline || [],
            positive2: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.month?.timeline || [],
            negative1: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.month?.timeline || [],
            negative2: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.month?.timeline || [],
            neutral1: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.month?.timeline || [],
            neutral2: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.month?.timeline || [],


            positive1val: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.month?.count || [],
            positive2val: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.month?.count || [],
            negative1val: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.month?.count || [],
            negative2val: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.month?.count || [],
            neutral1val: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.month?.count || [],
            neutral2val: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.month?.count || []
        }

        // trendsInUserActivity = compData?.[0]?.ci_report?.user_activity_trends?.month?.timeline || [];
        // trendsInUserActivityTopic2TimeLine = compData?.[1]?.ci_report?.user_activity_trends?.month?.timeline || [];
        // trendsInUserActivityTopic1Count = compData?.[0]?.ci_report?.user_activity_trends?.month?.count || [];
        // trendsInUserActivityTopic2Count = compData?.[1]?.ci_report?.user_activity_trends?.month?.count || [];
    }
    else if (timeSpan === 'Years') {
        if (jsonVal?.postOption == "Comments") {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_comment_trends?.year?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_comment_trends?.year?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_comment_trends?.year?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_comment_trends?.year?.count || []

            }
        } else {
            trendsInUserActivity = {
                Topic1TimeLine: compData?.[0]?.ci_report?.user_activity_trends?.year?.timeline || [],
                Topic2TimeLine: compData?.[1]?.ci_report?.user_activity_trends?.year?.timeline || [],
                Topic1Count: compData?.[0]?.ci_report?.user_activity_trends?.year?.count || [],
                Topic2Count: compData?.[1]?.ci_report?.user_activity_trends?.year?.count || []

            }
        }

        trendsInSentiments = {

            positive1: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.year?.timeline || [],
            positive2: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.year?.timeline || [],
            negative1: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.year?.timeline || [],
            negative2: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.year?.timeline || [],
            neutral1: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.year?.timeline || [],
            neutral2: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.year?.timeline || [],

            positive1val: compData?.[0]?.ci_report?.sentiment_trends?.positive_trends?.year?.count || [],
            positive2val: compData?.[1]?.ci_report?.sentiment_trends?.positive_trends?.year?.count || [],
            negative1val: compData?.[0]?.ci_report?.sentiment_trends?.negative_trends?.year?.count || [],
            negative2val: compData?.[1]?.ci_report?.sentiment_trends?.negative_trends?.year?.count || [],
            neutral1val: compData?.[0]?.ci_report?.sentiment_trends?.neutral_trends?.year?.count || [],
            neutral2val: compData?.[1]?.ci_report?.sentiment_trends?.neutral_trends?.year?.count || []
        }
        // trendsInUserActivity = compData?.[0]?.ci_report?.user_activity_trends?.year?.timeline || []; //post API integration, update with year attribute

        // trendsInUserActivityTopic2TimeLine = compData?.[1]?.ci_report?.user_activity_trends?.year?.timeline || [];
        // trendsInUserActivityTopic1Count = compData?.[0]?.ci_report?.user_activity_trends?.year?.count || [];
        // trendsInUserActivityTopic2Count = compData?.[1]?.ci_report?.user_activity_trends?.year?.count || [];
    }


    const handleTimeSpanClick = (option) => {
        setTimeSpan(option);
    };

    return (

        <ChildContainer >

            <Wrapper2>
                <Wrapper2Container>
                    <div>
                        <Title>
                            <p style={{ color: theme == true ? 'white' : 'rgb(99, 99, 99)' }}>{showTitleForSentiment ? 'Sentiment trend in User Activity' : 'Trends in User Activity'}</p>

                        </Title>


                        {/* <p style={{ color: theme == true ? 'white' : 'black', margin: '10px 0px', paddingLeft: '25px', fontSize: '12px' }}>Description : {desc}
                        </p> */}
                        <ToggleButton
                            options={['Days', 'Weeks', 'Months', 'Years']} //add years once api is available
                            onClick={handleTimeSpanClick}
                            padding='3px 30px'
                            option={timeSpan}
                        />
                    </div>
                    {
                        showGraphLabel ?

                            <GraphLabelContainer2>

                                <GraphLabel theme={theme} style={{ marginLeft: '0px', justifyContent: 'end' }}>
                                    <div>
                                        <span className='positive'></span>Positive
                                    </div>
                                    <div>
                                        <span className='negitive'></span>Negative
                                    </div>
                                    <div>
                                        <span className='neutral'></span>Neutral
                                    </div>
                                </GraphLabel>
                                <LabelContainer theme={theme}>

                                    <LineContainer theme={theme}>
                                        <div className="straight-line"></div><div className="title" data-testid="topic-1">
                                            <span className="icon">
                                                {compData?.[1]?.channel && compData?.[1]?.channel === 'twitter' ? X_LOGO :
                                                compData?.[1]?.channel == 'youtube' ? 
                                                <> <img src={YoutubeImg} style={{ width: '19px', marginTop: '0px' }} /></> :
                                                    compData?.[1]?.channel === 'instagram' ?  <> <img src={Insta} style={{width:'18px',marginTop:'3px'}} /></> :
                                                        compData?.[1]?.channel === 'facebook' ? FacebookLogoSmall :
                                                            compData?.[1]?.channel === 'flipkart' ?  <> <img src={Flip} style={{width:'18px',marginTop:'1px'}} /></>  : ''}
                                            </span>
                                            {compData?.[1]?.chatter_topic_title || ''}
                                        </div>

                                    </LineContainer>

                                    <LineContainer theme={theme}>
                                        <div className="dotted-line"></div>
                                        <div className="title" data-testid="topic-2">
                                            <span className="icon" theme={theme}>
                                                {compData?.[0]?.channel && compData?.[0]?.channel === 'twitter' ? X_LOGO :
                                                compData?.[0]?.channel == 'youtube' ? 
                                                <> <img src={YoutubeImg} style={{ width: '19px', marginTop: '0px' }} /></> :
                                                    compData?.[0]?.channel === 'instagram' ?  <> <img src={Insta} style={{width:'18px',marginTop:'3px'}} /></> :
                                                        compData?.[0]?.channel === 'facebook' ? FacebookLogoSmall :
                                                            compData?.[0]?.channel === 'flipkart' ?  <> <img src={Flip} style={{width:'18px',marginTop:'1px'}} /></>  : ''}
                                            </span>
                                            {compData?.[0]?.chatter_topic_title || ''}
                                        </div>

                                    </LineContainer>

                                </LabelContainer>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                    position: 'relative'
                                }}

                                    onMouseOver={() => setOpenDropDown(true)}
                                    onMouseLeave={() => setOpenDropDown(false)}
                                >
                                    {
                                        showFilter &&

                                        <FilterBtn>
                                            Filters
                                            {filter_icon}
                                        </FilterBtn>
                                    }
                                    {
                                        openDropDown === true &&

                                        <DropDownWrapper>

                                            <DropDownContentDiv>
                                                <div>
                                                    <InputDropDownCheckBox type='checkbox' checked={topic1Filter.positive || topic1Filter.negative || topic1Filter.neutral} onChange={(e) => handleChangeMainFilter(e)} /> {compData?.[0]?.chatter_topic_title || ''}

                                                </div>
                                                <InputDivWrapper>
                                                    <div style={{
                                                        width: '100%',
                                                        marginTop: '10px',

                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <InputDropDownCheckBox name="positive" type='checkbox' checked={topic1Filter.positive} onChange={(e) => handleChangeFilter(e)} /> Positive

                                                    </div>
                                                    <div style={{
                                                        width: '100%',
                                                        marginTop: '10px',

                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <InputDropDownCheckBox name="negative" type='checkbox' checked={topic1Filter.negative} onChange={(e) => handleChangeFilter(e)} /> Negative

                                                    </div>
                                                    <div style={{
                                                        width: '100%',
                                                        marginTop: '10px',

                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <InputDropDownCheckBox name="neutral" type='checkbox' checked={topic1Filter.neutral} onChange={(e) => handleChangeFilter(e)} /> Neutral

                                                    </div>

                                                </InputDivWrapper>


                                            </DropDownContentDiv>

                                            <DropDownContentDiv>
                                                <div>
                                                    <InputDropDownCheckBox type='checkbox' checked={topic2Filter.positive || topic2Filter.negative || topic2Filter.neutral} onChange={(e) => handleChangeMainFilter2(e)} /> {compData?.[1]?.chatter_topic_title || ''}

                                                </div>
                                                <InputDivWrapper>
                                                    <div style={{
                                                        width: '100%',
                                                        marginTop: '10px',

                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <InputDropDownCheckBox name="positive" type='checkbox' checked={topic2Filter.positive} onChange={(e) => handleChangeFilter2(e)} /> Positive

                                                    </div>
                                                    <div style={{
                                                        width: '100%',
                                                        marginTop: '10px',

                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <InputDropDownCheckBox name="negative" type='checkbox' checked={topic2Filter.negative} onChange={(e) => handleChangeFilter2(e)} /> Negative

                                                    </div>
                                                    <div style={{
                                                        width: '100%',
                                                        marginTop: '10px',

                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                        <InputDropDownCheckBox name="neutral" type='checkbox' checked={topic2Filter.neutral} onChange={(e) => handleChangeFilter2(e)} /> Neutral

                                                    </div>

                                                </InputDivWrapper>


                                            </DropDownContentDiv>

                                        </DropDownWrapper>

                                    }
                                </div>
                            </GraphLabelContainer2>
                            :

                            <GraphLabelContainer >
                                
                                <GraphLabel theme={theme} >
                                    <div>
                                        <span className='topic1'></span><span style={{ marginRight: '5px',alignItems:compData?.[0]?.channel == 'youtube' && 'flex-end',display:compData?.[0]?.channel == 'youtube' && 'flex'  }}>{compData?.[0]?.channel && compData?.[0]?.channel == 'twitter' ? X_LOGO : compData?.[0]?.channel == 'instagram' ?  <> <img src={Insta} style={{width:'15px',marginTop:'1px'}} /></> :compData?.[0]?.channel == 'youtube' ? <> <img src={YoutubeImg} style={{ width: '19px', marginTop: '0px' }} /></> :
                                        compData?.[0]?.channel == 'facebook' ? FacebookLogoSmall : compData?.[0]?.channel == 'flipkart' ?  <> <img src={Flip} style={{width:'18px',marginTop:'-3px'}} /></>  : ''}</span>

                                        {compData?.[0]?.chatter_topic_title || ''}
                                    </div>
                                    <div>
                                        <span className='topicB'></span>
                                        <span style={{ marginRight: '5px',alignItems:compData?.[1]?.channel == 'youtube' && 'flex-end',display:compData?.[1]?.channel == 'youtube' && 'flex'  }}>{compData?.[1]?.channel && compData?.[1]?.channel == 'twitter' ? X_LOGO : compData?.[1]?.channel == 'instagram' ?  <> <img src={Insta} style={{width:'15px',marginTop:'1px'}} /></> : compData?.[1]?.channel == 'youtube' ? <> <img src={YoutubeImg} style={{ width: '19px', marginTop: '0px' }} /></> : compData?.[1]?.channel == 'facebook' ? FacebookLogoSmall : compData?.[1]?.channel == 'flipkart' ?  <> <img src={Flip} style={{width:'18px',marginTop:'-3px'}} /></>  : ''}</span>
                                        {compData?.[1]?.chatter_topic_title || ''}
                                    </div>
                                </GraphLabel>
                                {
                                    (compData?.[0]?.channel == 'instagram' || compData?.[0]?.channel == 'youtube' || compData?.[1]?.channel == 'youtube' || compData?.[1]?.channel == 'instagram' || compData?.[0]?.channel == 'facebook' || compData?.[1]?.channel == 'facebook') &&

                                    <div style={{ marginTop: '10px',display:'flex',justifyContent:'end' }}>
                                        <ToggleButton
                                            options={['Posts', "Comments"]} //add years once api is available
                                            onClick={handleTimeSpanClick}
                                            padding='3px 20px'
                                            option={jsonVal?.postOption}
                                            value={jsonVal?.postOption}
                                        />
                                    </div>
                                }
                            </GraphLabelContainer>
                    }
                </Wrapper2Container>
                <MainContainer graphWidth={isZoom80 ? '950px': ''}>
                    {
                        showGraphLabel ?

                            <div ref={divRef} style={{ width: '100%', height: '100%' }} >
                                <TrendsInSentiments
                                    shared={shared}
                                    theme={theme}
                                    showFilter={showFilter}
                                    width={isZoom80 ? 850 : 950}
                                    trendsDataSet={trendsDataSet}
                                    topic1Filter={topic1Filter}
                                    topic2Filter={topic2Filter}
                                    // title_1={compData?.[1]?.chatter_topic_title || ''}
                                    // title_2={''}
                                    title_2={compData?.[1]?.chatter_topic_title || ''}
                                    title_1={compData?.[0]?.chatter_topic_title || ''}
                                    positive_value_1={trendsInSentiments?.positive1val}
                                    negative_value_1={trendsInSentiments?.negative1val}
                                    neutral_value_1={trendsInSentiments?.neutral1val}
                                    // positive_value_2={''}
                                    // negative_value_2={''}
                                    downloadFeature={downloadFeature}
                                    // neutral_value_2={''}
                                    positive_value_2={trendsInSentiments?.positive2val}
                                    negative_value_2={trendsInSentiments?.negative2val}
                                    neutral_value_2={trendsInSentiments?.neutral2val}

                                    positive_date_1={trendsInSentiments?.positive1}
                                    // positive_date_2={''}
                                    positive_date_2={trendsInSentiments?.positive2}
                                    negative_date_1={trendsInSentiments?.negative1}
                                    // negative_date_2={''}
                                    negative_date_2={trendsInSentiments?.negative2}
                                    neutral_date_1={trendsInSentiments?.neutral1}
                                    // neutral_date_2={''}
                                    neutral_date_2={trendsInSentiments?.neutral2}
                                // topic1_dates={trendsInUserActivity || []}
                                // topic2_dates={trendsInUserActivityTopic2TimeLine || []}
                                // topic1_values={trendsInUserActivity || []}
                                // topic2_values={trendsInUserActivityTopic2Count || []}
                                />
                            </div>
                            :
                            <div style={{ width: '100%', height: '100%' }}>
                                <TrendsInUserActivity
                                    theme={theme}
                                    title1={compData?.[0]?.chatter_topic_title || ''}
                                    shared={shared}
                                    title2={compData?.[1]?.chatter_topic_title || ''}
                                    
                                    width={isZoom80 ? 850 : 950}
                                    // topic1_dates={trendsInUserActivity?.Topic2TimeLine || []}
                                    // topic2_dates={[]}
                                    // topic1_values={trendsInUserActivity?.Topic2Count || []}
                                    // topic2_values={[]}
                                    downloadFeature={downloadFeature}
                                    topic1_dates={trendsInUserActivity?.Topic1TimeLine || []}
                                    topic2_dates={trendsInUserActivity?.Topic2TimeLine || []}
                                    topic1_values={trendsInUserActivity?.Topic1Count || []}
                                    topic2_values={trendsInUserActivity?.Topic2Count || []}
                                    trendsDataSet={trendsDataSet} />
                            </div>

                    }
                </MainContainer>
                {
                    showsummary ?
                        <MainComponent2 >
                            <ParagraphBold theme={theme}>{compData?.[0]?.chatter_topic_title || ''} Reviews: <ParagraphNormal theme={theme}>{summary1}</ParagraphNormal></ParagraphBold>
                            <ParagraphBold theme={theme}>

                                {compData?.[1]?.chatter_topic_title || ''} Reviews: <ParagraphNormal theme={theme}>{summary2}</ParagraphNormal>
                            </ParagraphBold>
                            {/* <ParagraphBold>
                        Initial Peak: <ParagraphNormal>Both devices started strong with 300 reviews each on January 1st, before the decline.</ParagraphNormal>

                    </ParagraphBold> */}
                        </MainComponent2>
                        :
                        <MainComponent2 >
                            <ParagraphBold theme={theme} >
                                {compData?.[0]?.chatter_topic_title || ''} Reviews:


                                <ul>
                                    {
                                        topic1Filter.positive &&
                                        <li style={{ color: theme == true ? 'white' : 'black' }}>
                                            <span style={{ color: 'rgb(16 115 56)' }}>Positive Sentiment : </span><span style={{
                                                fontSize: '12px', fontWeight: 400,
                                                color: theme == true ? 'white' : 'black',
                                            }}>{summary1?.positive_trends?.data_1}</span>
                                        </li>
                                    }

                                    {
                                        topic1Filter.negative &&

                                        <li style={{ color: theme == true ? 'white' : 'black' }}>
                                            <span style={{ color: 'rgba(238, 19, 7, 1)' }} >Negative Sentiment : </span><span style={{
                                                fontSize: '12px', fontWeight: 400,
                                                color: theme == true ? 'white' : 'black',
                                            }}>{summary1?.negative_trends?.data_1}</span>
                                        </li>
                                    }

                                    {
                                        topic1Filter.neutral &&
                                        <li style={{ color: theme == true ? 'white' : 'black' }}>
                                            <span style={{ color: 'rgb(200 144 3)' }}>Neutral Sentiment :  </span><span style={{
                                                fontSize: '12px', fontWeight: 400,
                                                color: theme == true ? 'white' : 'black',
                                            }}>{summary1?.neutral_trends?.data_1}</span>
                                        </li>
                                    }

                                </ul>
                            </ParagraphBold>
                            <ParagraphBold theme={theme}>

                                {compData?.[1]?.chatter_topic_title || ''} Reviews:

                                <ul>
                                    {
                                        topic2Filter.positive &&

                                        <li style={{ color: theme == true ? 'white' : 'black' }}>
                                            <span style={{ color: 'rgb(16 115 56)' }}>Positive Sentiment : </span><span style={{
                                                fontSize: '12px', fontWeight: 400,
                                                color: theme == true ? 'white' : 'black',
                                            }}>{summary1?.positive_trends?.data_2}</span>
                                        </li>
                                    }

                                    {
                                        topic2Filter.negative &&

                                        <li style={{ color: theme == true ? 'white' : 'black' }}>
                                            <span style={{ color: 'rgba(238, 19, 7, 1)' }}>Negative Sentiment : </span><span style={{
                                                fontSize: '12px', fontWeight: 400,
                                                color: theme == true ? 'white' : 'black',
                                            }}>{summary1?.negative_trends?.data_2}</span>
                                        </li>
                                    }

                                    {
                                        topic2Filter.neutral &&

                                        <li style={{ color: theme == true ? 'white' : 'black' }}>
                                            <span style={{ color: 'rgb(200 144 3)' }}>Neutral Sentiment : </span> <span style={{
                                                fontSize: '12px', fontWeight: 400,
                                                color: theme == true ? 'white' : 'black',
                                            }}>{summary1?.neutral_trends?.data_2}</span>
                                        </li>
                                    }

                                </ul>
                            </ParagraphBold>
                            {/* <ParagraphBold>
                    Initial Peak: <ParagraphNormal>Both devices started strong with 300 reviews each on January 1st, before the decline.</ParagraphNormal>

                </ParagraphBold> */}
                        </MainComponent2>
                }


                {/* <Span>
  This data is observed from {startDate} to {endDate}
</Span> */}
            </Wrapper2>
        </ChildContainer>
    );
};


export default TrendsMainContainer;